import module from 'nominas/finiquito/module.js'
import template from './template.html'
import './style.scss'

export class NominasFiniquitoEscenarioConceptosConceptoComponent {
  salarioDiario
  editable
  data
  extendido
  onChange
  onDelete

  constructor ($parse) {
    this.$parse = $parse
  }

  $onChanges (changes) {
    if (changes.salarioDiario && !changes.salarioDiario.isFirstChange()) {
      this.calcular()
    }

    if (changes.data) {
      if (this.data.calculo_importe) {
        this.data.calculo_importe = `importe = ${this.data.calculo_importe}`
      }

      this.parse = this.$parse(this.data.calculo_importe)
    }
  }

  calcular () {
    this.parse(this.data, {salario_diario: this.salarioDiario})

    this.data.horas = this.data.horas ? parseFloat(this.data.horas.toFixed(2)) : null
    this.data.dias = this.data.dias ? parseFloat(this.data.dias.toFixed(2)) : null
    this.data.importe = this.data.importe ? parseFloat(this.data.importe.toFixed(2)) : null

    this.onChange({$event: {data: this.data}})
  }

  eliminar () {
    this.onDelete({$event: {data: this.data}})
  }
}

module.component('nominasFiniquitoEscenarioConceptosConcepto', {
  controller: NominasFiniquitoEscenarioConceptosConceptoComponent,
  template,
  bindings: {
    salarioDiario: '<',
    editable: '<',
    data: '<',
    extendido: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/conceptos/concepto/component.js